export enum TABLE_TYPE {
  'Swap' = 'Swap',
  'Add' = 'Add Liquidity',
  'Remove' = 'Remove Liquidity'
}